import { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import api from "../../../services/api";
import {IEventDate} from "../../../interfaces/IEventDate";

export default function EventDatesList() {
  const { id } = useParams()
  const [eventDates, setEventDates] = useState<IEventDate[]>([])
  const navigate = useNavigate()


  useEffect(() => {
    api.get('/api/event_dates/stage/' + id)
      .then(resposta => {
          setEventDates(resposta.data)
      })
  }, [])

  return (
    <>
      <div className='row'>
        <div className='col-md-12'>
          <h3 className='mb-2'>
            <b>Datas</b>
          </h3>
        </div>
      </div>

      <div className='row my-4'>
        {eventDates.map(date =>
          <div key={date.id} className='col-md-4 mt-3'>
            <div className='card'>
              <div className='card-body'>
                {/*<h2><b>{formatDa(date.date, 'data')}</b></h2>*/}
                <h2><b>{date.match_date}</b></h2>
                <Link to={'/event-entries/' + date.id} className='btn btn-block btn-primary'>Acessar</Link>
              </div>
            </div>
          </div>
        )}

      </div>
      <div className='row'>
          <div className='col-md-12 text-right'>
              <button className="btn btn-danger btn-floating" onClick={() => navigate(-1)}>Voltar<br/></button>
          </div>
    </div>
</>
)
}
